let natures = document.querySelector('.natures'), ville = document.querySelector('.ville'), danse = document.querySelector('.danse')

// Prismic	
let Prismic = require('prismic-javascript');
const main = document.querySelector('main')
 
let apiEndpoint = "https://olivier-geffard.prismic.io/api/v2";
 
Prismic.getApi(apiEndpoint).then(function(api) {
  return api.getByID('Xi1h9hAAACMA9aIg'); // An empty query will return all the documents
}).then(function(response) {
  let images = response.data.paysage

  for (const image of images) {
    const container = document.createElement('div')
    container.classList.add('imageContener')
    const imageContainer = document.createElement('img')
    const textContainer = document.createElement('div')
    textContainer.classList.add('galery_text')
    const text = document.createElement('p')

    imageContainer.setAttribute('src', image.image.url)
    text.innerHTML = image.image.alt

    container.appendChild(imageContainer)
    textContainer.appendChild(text)
    container.appendChild(textContainer)
    main.appendChild(container)
  }
}, function(err) {
  console.log("Something went wrong: ", err);
});

ville.addEventListener(
  'click',
  () => {
    const current = document.querySelector('.current')

    // Remove all content
    while (main.firstChild) {
      main.removeChild(main.firstChild)
    }

    // Change content
    Prismic.getApi(apiEndpoint).then(function(api) {
      return api.getByID('Xi1h9hAAACMA9aIg'); // An empty query will return all the documents
    }).then(function(response) {
      let images = response.data.urbain
    
      for (const image of images) {
        const container = document.createElement('div')
        container.classList.add('imageContener')
        const imageContainer = document.createElement('img')
        const textContainer = document.createElement('div')
        textContainer.classList.add('galery_text')
        const text = document.createElement('p')
    
        imageContainer.setAttribute('src', image.image.url)
        text.innerHTML = image.image.alt
    
        container.appendChild(imageContainer)
        textContainer.appendChild(text)
        container.appendChild(textContainer)
        main.appendChild(container)
      }
    }, function(err) {
      console.log("Something went wrong: ", err);
    });

    current.classList.remove('current')
    ville.firstChild.firstChild.classList.add('current')
  }
)


natures.addEventListener(
  'click',
  () => {
    const current = document.querySelector('.current')

    // Remove all content
    while (main.firstChild) {
      main.removeChild(main.firstChild)
    }

    // Change content
    Prismic.getApi(apiEndpoint).then(function(api) {
      return api.getByID('Xi1h9hAAACMA9aIg'); // An empty query will return all the documents
    }).then(function(response) {
      let images = response.data.paysage
    
      for (const image of images) {
        const container = document.createElement('div')
        container.classList.add('imageContener')
        const imageContainer = document.createElement('img')
        const textContainer = document.createElement('div')
        textContainer.classList.add('galery_text')
        const text = document.createElement('p')
    
        imageContainer.setAttribute('src', image.image.url)
        text.innerHTML = image.image.alt
    
        container.appendChild(imageContainer)
        textContainer.appendChild(text)
        container.appendChild(textContainer)
        main.appendChild(container)
      }
    }, function(err) {
      console.log("Something went wrong: ", err);
    });

    current.classList.remove('current')
    natures.firstChild.firstChild.classList.add('current')
  }
)

danse.addEventListener(
  'click',
  () => {
    const current = document.querySelector('.current')

    // Remove all content
    while (main.firstChild) {
      main.removeChild(main.firstChild)
    }

    // Change content
    Prismic.getApi(apiEndpoint).then(function(api) {
      return api.getByID('Xi1h9hAAACMA9aIg'); // An empty query will return all the documents
    }).then(function(response) {
      let images = response.data.recherches
    
      for (const image of images) {
        const container = document.createElement('div')
        container.classList.add('imageContener')
        const imageContainer = document.createElement('img')
        const textContainer = document.createElement('div')
        textContainer.classList.add('galery_text')
        const text = document.createElement('p')
    
        imageContainer.setAttribute('src', image.image.url)
        text.innerHTML = image.image.alt
    
        container.appendChild(imageContainer)
        textContainer.appendChild(text)
        container.appendChild(textContainer)
        main.appendChild(container)
      }
    }, function(err) {
      console.log("Something went wrong: ", err);
    });

    current.classList.remove('current')
    danse.firstChild.firstChild.classList.add('current')
  }
)
